import { createApp } from 'vue';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import router from './router';
import store from './store';
import '@/assets/fonts.css';
import '@/assets/colores.css';
import '@/assets/global.css';
import '@/assets/transitions.css';
import i18n from '@/i18n';

createApp(App).use(router).use(store).use(i18n).mount('#app');
